import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private http:HttpClient) {
  }

  public getProfileFormData(): Observable<any> {
    return this.http.get(environment.BASE_URL_COMMON + 'cmn/getProfileFormData')
  }

  public getProfileFormDataLgsp(): Observable<any> {
    return this.http.get(environment.BASE_URL_LGSP + 'cmn/getProfileFormData')
  }

  public getContactDetails(): Observable<any>{
    return this.http.get(environment.BASE_URL_PROFILE+"profile/getContactDetails")
  }
}
